export enum TransferType {
    BUS = "BUS",
    TAXI = "TAXI",
    FUNICULAR = "FUNICULAR",
    NONE = "NONE"
}

export enum TripType {
    ROUND_TRIP = "ROUND_TRIP",
    ONE_WAY_OUTBOUND = "ONE_WAY_OUTBOUND",
    ONE_WAY_RETURN = "ONE_WAY_RETURN"  // Changed from ONE_WAY_INBOUND
}

export enum BusBookingStatus {
    //First process with time computation
    PENDING_TIMES = "PENDING_TIMES",
    PROCESSING_TIMES = "PROCESSING_TIMES",
    ERROR_TIMES = "ERROR_TIMES",

    // Ready to be booked (has all required data) but not automatically booking
    READY = "READY",

    //Set manually via UI from a READY order, processing the booking in Altibus automatically
    TO_BOOK = "TO_BOOK",
    PROCESSING_BOOK = "PROCESSING_BOOK",
    ERROR_BOOK = "ERROR_BOOK",
    BOOKED = "BOOKED",
    PARTIALLY_BOOKED = "PARTIALLY_BOOKED", // For round trips where only one leg is booked

    //Cancelation
    TO_CANCEL = "TO_CANCEL",
    CANCELLED = "CANCELLED",

    //When we receive a new booking for the same reference with different bus, we need to mark the old one as deprecated (until it is replaced by a new PENDING_TIMES)
    DEPRECATED = "DEPRECATED",
}